<template>
  <div class="imgBox min-w-1400">
    <div class="imgBox1 min-w-1400">
      <div class="img1Box max-w-1400">
        <!-- <img :src="importedImg11" alt="" class="imgItem1" /> -->
         <!-- <p>Hang ổ của bạn</p> -->
        <div class="swiper-container">
          <div class="swiper-wrapper">
            <div
              class="swiper-slide"
              v-for="(image, index) in images"
              :class="{zoom: zoomIndex === index}"
              :key="index"
            >
              <img :src="image.src" :alt="image.alt" />
            </div>
          </div>
          <!-- 如果需要分页 -->
          <div class="swiper-pagination"></div>
          <!-- 导航按钮 -->
          <!-- <div class="swiper-button-next"></div>
          <div class="swiper-button-prev"></div> -->
        </div>
      </div>
    </div>
    <div class="imgBox2 min-w-1400">
      <div class="img2Box max-w-1400">
        <img :src="importedImg2" alt="" class="imgItem2" />
      </div>
    </div>
    <div class="imgBox5 min-w-1400">
      <div class="img5Box max-w-1400">
        <img :src="importedImg5" alt="" class="imgItem5" />
      </div>
    </div>
    <div class="imgBox3 min-w-1400">
      <div class="img3Box max-w-1400">
        <img :src="importedImg3" alt="" class="imgItem3" />
      </div>
    </div>
    <div class="imgBox4 min-w-1400">
      <div class="img4Box max-w-1400">
        <img :src="importedImg4" alt="" class="imgItem4" />
      </div>
    </div>


    <div class="imgBox6 min-w-1400">
      <div class="img6Box max-w-1400">
        <!-- <img :src="importedImg6" alt="" class="imgItem6" /> -->
        <p>คุณสมบัติของเรา</p>
        <div class="imgWrapper">
          <img :src="imported5Img1" alt="" class="imgItem6" />
          <img :src="imported5Img2" alt="" class="imgItem6" />
          <img :src="imported5Img3" alt="" class="imgItem6" />
          <img :src="imported5Img4" alt="" class="imgItem6" />

          <img :src="imported5Img1" alt="" class="imgItem6" />
          <img :src="imported5Img2" alt="" class="imgItem6" />
          <img :src="imported5Img3" alt="" class="imgItem6" />
          <img :src="imported5Img4" alt="" class="imgItem6" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import "./index.css";
// import Swiper from "swiper";
import Swiper from "swiper/bundle";
// import styles bundle
import "swiper/css/bundle";

import importedImg1 from "@/page/growmoney/components/img/1_1.png";
import imported1Img1 from "@/page/growmoney/components/img/1_1_1.png";
import imported1Img2 from "@/page/growmoney/components/img/1_1_2.png";
import imported1Img3 from "@/page/growmoney/components/img/1_1_3.png";
import importedImg2 from "@/page/growmoney/components/img/1_2.png";
import importedImg3 from "@/page/growmoney/components/img/1_3.png";
import importedImg4 from "@/page/growmoney/components/img/1_4.png";
import imported5Img1 from "@/page/growmoney/components/img/1_5_1.png";
import imported5Img2 from "@/page/growmoney/components/img/1_5_2.png";
import imported5Img3 from "@/page/growmoney/components/img/1_5_3.png";
import imported5Img4 from "@/page/growmoney/components/img/1_5_4.png";
import importedImg5 from "@/page/growmoney/components/img/1_5.png";
// import importedImg6 from "@/page/growmoney/components/img/1_6.png";

export default {
  data() {
    return {
      importedImg1: importedImg1,
      importedImg2: importedImg2,
      importedImg3: importedImg3,
      importedImg4: importedImg4,
      importedImg5: importedImg5,
      // importedImg6: importedImg6,
      imported5Img1:imported5Img1,
      imported5Img2:imported5Img2,
      imported5Img3:imported5Img3,
      imported5Img4:imported5Img4,
      images: [
        // { src: importedImg11, alt: "Image 1" },
        { src: imported1Img1, alt: "Image 2" },
        { src: imported1Img2, alt: "Image 3" },
        { src: imported1Img3, alt: "Image 3" },
        // { src: importedImg14, alt: "Image 4" },
        // { src: importedImg15, alt: "Image 5" },
        // { src: importedImg13, alt: "Image 3" },
      ],
      altText: "图片",
    };
  },
  created() {
    this.gotoTop();
  },
  mounted() {
    // 初始化 Swiper
    new Swiper(".swiper-container", {
      loop: true, // 循环模式
      autoplay: {
        delay: 3000, // 每3秒切换一次
        disableOnInteraction: false,
      },
      preloadImages: true,
      slidesPerView: 1, // 一次显示3张图片
      spaceBetween: 0, // 图片之间的间距
      centeredSlides: true,
      speed: 3000,
      pagination: {
        el: ".swiper-pagination", // 分页器
        clickable: true, // 可以点击分页器跳转
      },
      navigation: {
        nextEl: ".swiper-button-next", // 下一张按钮
        prevEl: ".swiper-button-prev", // 上一张按钮
      },
      // scrollbar: {
      //   el: ".swiper-scrollbar", // 滚动条
      // },
      // on: {
      //   slideChange: function () {
      //     console.log("当前滑动的索引是: ", this.realIndex);
      //     this.zoomIndex = this.realIndex;
      //     // 在这里执行你想做的操作
      //   },
      // },
    });
  },
  methods: {
    gotoTop() {
      window.scrollTo({ top: 0, behavior: "smooth" });
    },
  },
};
</script>

<style scoped>
.swiper-container {
  position: relative;
  width: 100%;
  /* height: 100vh; */
}
.swiper-slide{
  transition: transform 5s linear;
  display: flex;
  align-items: center;
}


.swiper-slide img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.swiper-pagination {
  position: absolute;
  left: 0;
  right: 0;
  text-align: center; /* 确保分页器居中 */
}


.imgBox {
  display: flex;
  flex-direction: column;
  background-color: white;
}
img {
  display: block;
}
.imgBox1,
.imgBox2,
.imgBox3,
.imgBox4,
.imgBox5,
.imgBox6,
.imgBox7 {
  display: flex;
  justify-content: center;
  width: 100%;
  background-color: "";
}

.img1Box,
.img2Box,
.img3Box,
.img4Box,
.img5Box,
.img6Box,
.img7Box {
  margin: 0;
  overflow: hidden;
  width: 100%;
  background-color: "";
}

.imgItem1,
.imgItem2,
.imgItem3,
.imgItem4,
.imgItem5,
.imgItem6,
.imgItem7 {
  width: 100%;
  margin: 0;
}

.img2Box{
  padding: 100px 200px;
}
.img3Box{
  padding: 0 180px;
}
.img4Box{
  padding: 0 200px;
}

.img5Box{
  padding: 0 220px 140px;
}



/* 容器最大宽度 */
.img6Box {
  width: 100%;
  overflow: hidden;
  position: relative; /* 定位容器 */
}
.img6Box p{
  text-align: center;
  font-size: 48px;
  font-weight: bold;
  margin-top: 50px;
  font-family: PT Sans, sans-serif;
}

/* 包裹图片的外层容器 */
.imgWrapper {
  display: flex; /* 横向排列图片 */
  animation: moveImages 20s linear infinite;
  /* 动画控制，15s 为动画周期，线性平滑过渡，永远循环 */
  height: 300px;
}

/* 每张图片的样式 */
.imgItem6 {
  width: 450px;
  height: 200px; /* 图片的高度可以根据需求调整 */
  margin-right: 30px; /* 图片之间的间距 */
  margin-top: 40px;
  /* animation: moveImages 36s linear infinite; */
}
.imgItem6 img{
  width: 100%;
  height: 100%;
}
.imgItem6:hover {
  /* box-shadow: 0px 8px 15px rgba(0, 0, 0, 0.3);  */
  /* 8px的垂直偏移，15px的模糊半径，30%透明度的黑色阴影 */
}
/* .imgItem6:nth-child(2n) {
  margin-top: 110px;
} */

/* 关键帧动画：让图片从右往左移动 */
@keyframes moveImages {
  0% {
    transform: translateX(0); /* 起始位置 */
  }
  100% {
    transform: translateX(-1880px); /* 最终位置，6张图片，每张600px，移动 6*600px */
  }
}
</style>
